// IMPORTANT!!
//
// To add a new analytics event, you MUST:
// 1) Add a const below representing the event's action, actionSubject, and details
// 2) Add the const from step 1 to the default export
//
// If you skip any step, you will cause issues for the consumer, because they will not
// have any way to query this event.

import { ANALYTICS_ACTION_CLICKED, ANALYTICS_ACTION_COLLAPSED, ANALYTICS_ACTION_EXPANDED, ANALYTICS_ACTION_RENDERED, ANALYTICS_SUBJECT_BUTTON, ANALYTICS_SUBJECT_LINK, FilterClickedEvent, OPERATIONAL_EVENT_TYPE, UI_EVENT_TYPE } from '@atlassian/mpac-analytics';
import { List } from 'immutable';
export const EVENT_CHANNEL = 'addonDiscovery';
export const EVENT_SOURCE = 'addonDiscovery';
export const ANALYTICS_EVENT_SOURCE_APP_TILE = 'appTile';
export const OBJECT_TYPE_APP = 'app';
export const OBJECT_TYPE_FILTER = 'filter';

// Analytics Action Subjects
const ANALYTICS_SUBJECT_FACET = 'facet';
const ANALYTICS_SUBJECT_TILE = 'tile';
const ANALYTICS_SUBJECT_TILES = 'tiles';

// Analytics Action Subject IDs
export const ANALYTICS_SUBJECT_ID_COLLECTION_VIEW_MORE_LINK = 'collectionViewMoreLink';
export const ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH = 'standardTextSearch';
export const ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_MENU_APPLY_BUTTON = 'mobileDropdownMenuApplyButton';
export const ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_TOGGLE_BUTTON = 'mobileDropdownToggleButton';
export const ANALYTICS_SUBJECT_ID_SEARCH_RESULTS_LOAD_MORE_BUTTON = 'searchResultsLoadMoreButton';
export const ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER = 'topbarFacetFilter';
export const ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER = 'sidebarFacetFilter';
export const ANALYTICS_SUBJECT_ID_TILE_CATEGORY_FILTER = 'tileCategoryFilter';
export const ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON = 'currentFilterXRemoveIcon';
export const ANALYTICS_SUBJECT_ID_TOPBAR_FACET = 'topbarFacet';
export const ANALYTICS_SUBJECT_ID_SIDEBAR_FACET = 'sidebarFacet';
export const ANALYTICS_SUBJECT_ID_COLLECTION_TILE = 'collectionTile';
export const ANALYTICS_SUBJECT_ID_DISCOVER_TILES = 'discoverTiles';
export const ANALYTICS_SUBJECT_ID_SEARCH_TILES = 'searchTiles';
export const ANALYTICS_SUBJECT_ID_HIT = 'hit';
export const ANALYTICS_SUBJECT_ID_RIGHT_CLICK_HIT = 'rightHit';
export const ButtonClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_BUTTON,
  details: 'User clicked a button',
  type: UI_EVENT_TYPE
};
export const FacetCollapsedEvent = {
  action: ANALYTICS_ACTION_COLLAPSED,
  actionSubject: ANALYTICS_SUBJECT_FACET,
  details: 'User has collapsed a search facet',
  type: UI_EVENT_TYPE
};
export const FacetExpandedEvent = {
  action: ANALYTICS_ACTION_EXPANDED,
  actionSubject: ANALYTICS_SUBJECT_FACET,
  details: 'User has expanded a search facet',
  type: UI_EVENT_TYPE
};
export const LinkClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_LINK,
  details: 'User clicked a link',
  type: UI_EVENT_TYPE
};
export const TileClickedEvent = {
  action: ANALYTICS_ACTION_CLICKED,
  actionSubject: ANALYTICS_SUBJECT_TILE,
  details: 'User clicked a tile',
  type: UI_EVENT_TYPE
};
export const TileRenderedEvent = {
  action: ANALYTICS_ACTION_RENDERED,
  actionSubject: ANALYTICS_SUBJECT_TILE,
  details: 'A Marketplace app tile was rendered and is now visible to the user',
  type: OPERATIONAL_EVENT_TYPE
};
export const TilesRenderedEvent = {
  action: ANALYTICS_ACTION_RENDERED,
  actionSubject: ANALYTICS_SUBJECT_TILES,
  details: 'Marketplace app tiles were rendered and are now visible to the user',
  type: UI_EVENT_TYPE
};
export default List([ButtonClickedEvent, FacetCollapsedEvent, FacetExpandedEvent, LinkClickedEvent, TileClickedEvent, TileRenderedEvent, TilesRenderedEvent, FilterClickedEvent]);